import { useState } from "react";
import { useHistory } from "react-router-dom";
import { CloseButton } from "../../Components/CloseButton";
import Footer from "../../Components/Footer";
import ModalElement from "../../Components/Modal";
import { UserForm } from "../../Components/UserForm";
import { useUser } from "../../Providers/User";
import { Container, ContainerMenu } from "./styles";
import { ServicesIcon } from "../../Components/MenuIcons/ServicesIcon";
import { HotelIcon } from "../../Components/MenuIcons/HotelIcon";
import { GuestIcon } from "../../Components/MenuIcons/GuestIcon";
import { ColabIcon } from "../../Components/MenuIcons/ColabIcon";
import { EditUserIcon } from "../../Components/MenuIcons/EditUserIcon";

const Dashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const { currentUser } = useUser();

  const history = useHistory();

  if (currentUser) {
    return (
      <Container>
        <ContainerMenu>
          <ServicesIcon onClick={() => history.push("/products_services")} />
          <HotelIcon onClick={() => history.push("/unitHabits")} />
          <GuestIcon onClick={() => history.push("/products_services")} />
          <ColabIcon onClick={() => history.push("/colaborators")} />
          <EditUserIcon onClick={() => setShowModal(true)} />
          <CloseButton logoutButton />
        </ContainerMenu>

        <ModalElement closeModal={() => setShowModal(false)} isOpen={showModal}>
          <UserForm user={currentUser} />
        </ModalElement>
        <Footer />
      </Container>
    );
  } else {
    return (
      <Container>
        Seu token expirou
        <CloseButton logoutButton />
        <Footer />
      </Container>
    );
  }
};

export default Dashboard;
